import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import FAQ from "@/components/FAQ";
import { FadeUp, CTAButton, EASE } from "@/components/Reveal";
import { FAQ_ITEMS } from "@/data/content";

const FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqPage() {
  return (
    <>
      <SEO
        title="Veelgestelde vragen over het energielabel | Directelabels"
        description="Antwoorden op veelgestelde vragen over het energielabel: de duur van een woningopname, benodigde documenten, kosten, geldigheid en het werkgebied van Directelabels in Rotterdam en Zuid-Holland."
        path="/faq"
        jsonLd={FAQ_JSONLD}
      />

      <section data-testid="faq-hero" className="mx-auto max-w-7xl px-5 pb-8 pt-14 md:px-8 md:pt-24">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="text-xs font-bold uppercase tracking-[0.24em] text-primary"
        >
          Veelgestelde vragen
        </motion.p>
        <h1 data-testid="faq-title" className="mt-6 font-display text-4xl font-semibold leading-tight tracking-tighter text-ink md:text-6xl">
          <span className="block overflow-hidden pb-1">
            <motion.span className="block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay: 0.15, ease: EASE }}>
              Antwoorden op uw vragen.
            </motion.span>
          </span>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45, ease: EASE }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg"
        >
          Alles over de woningopname, de kosten, de geldigheid en het werkgebied van Directelabels. Staat uw vraag er
          niet tussen? Neem gerust contact met ons op.
        </motion.p>
      </section>

      <section data-testid="faq-list" className="mx-auto max-w-4xl px-5 pb-16 pt-8 md:px-8">
        <FadeUp>
          <FAQ items={FAQ_ITEMS} />
        </FadeUp>
        <FadeUp delay={0.15}>
          <div className="mt-14 rounded-3xl border border-black/5 bg-white p-8 text-center shadow-sm md:p-10">
            <h2 className="font-display text-2xl font-medium tracking-tight text-ink">Uw vraag staat er niet bij?</h2>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-muted-foreground md:text-base">
              Stuur ons een bericht via het contactformulier. Wij reageren op werkdagen binnen 24 uur.
            </p>
            <CTAButton to="/contact" testid="faq-page-cta" className="mt-7">
              Stel uw vraag
            </CTAButton>
          </div>
        </FadeUp>
      </section>
    </>
  );
}
